<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <blaze />
    <!-- <router-view /> -->
    <div class="copyright">Copyright August 2020 - present</div>
  </div>
</template>
<script>
import blaze from "@/components/Layout/Blaze";
export default {
  data() {
    return {};
  },
  components: {
    blaze
  },
  computed: {},
  methods: {},
  watch: {},
  mounted() {}
};
</script>
<style>
@import "~@/assets/styles/app.less";
.copyright {
  position: fixed;
  width: 100vw;
  text-align: center;
  background-color: #ddd;
  bottom: 10px;
  font-size: 12px;
}
</style>
